import { Component, OnInit, ViewChild } from "@angular/core";
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { producto } from 'src/app/shared/object/producto.model';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { RutService } from "src/app/shared/services/rut.service";
import { ConsoleService } from "src/app/shared/services/console.service";
import { ProductosFormDatosComercialesComponent } from "../form-datos-comerciales/form-datos-comerciales.component";

@Component({
  selector: 'app-productos-modal-datos-comerciales',
  templateUrl: './modal-datos-comerciales.component.html',
  styleUrls: ['../productos.component.scss'],
  providers: [SecurityService]
})
export class ProductoModalDatosComercialesComponent implements OnInit {

  @ViewChild(ProductosFormDatosComercialesComponent, { static: true }) datosComercialesComponent: ProductosFormDatosComercialesComponent

  // Modales
  @ViewChild('editarComerciales', { static: true }) editarComercialesModal: ModalDirective;

  // Form && Main Data
  rut_empresa: number;
  sucursal_codigo: number;
  codgo_modulo: number = 2;
  rut_usuario: number;

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private toastService: ToastService,
    private rutService: RutService,
    private clog: ConsoleService,
  ) {
    this.log = this.clog.log('PRODUCTOS-ADD/EDIT / DATOS COMERCIALES')
  }

  ngOnInit() {
    this.rut_empresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursal_codigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rut_usuario = Number(this.accesolocalstorage.getRutUsuario())
  }

  public loadAndShow(producto: producto, parametro_iva: number) {
    this.datosComercialesComponent.loadAndShow(producto, parametro_iva)
    this.editarComercialesModal.show()
  }

  guardarEditar() {
    const isValid = this.datosComercialesComponent.validate()
    if (!isValid) {
      this.toastService.warning('Complete el formulario')
      return
    }
    this.datosComercialesComponent.actualizarDatosComerciales()
  }

  onSucessSaveDatosComerciales() {
    this.editarComercialesModal.hide()
  }

}
